import { GREEN } from "@finway-group/shared/lib/consts"
import { Employee, User } from "@finway-group/shared/lib/models"
import { Avatar, Skeleton } from "antd"
import React, { useEffect } from "react"
import { doesImageExist } from "Shared/utils/helpers"
import useStateIfMounted from "Shared/utils/hooks/useStateIfMounted"

interface UserImageInterface {
    user: Employee | User
    size?: "large" | "small" | number
}
const UserImage: React.FC<UserImageInterface> = ({ user, size = "small" }) => {
    if (!user) return <></>

    const [imgLoading, setImgLoading] = useStateIfMounted<boolean>(true)
    const [showInitials, setShowInitials] = useStateIfMounted<boolean>(false)

    const initInitialAvatar = () => {
        setImgLoading(false)
        setShowInitials(true)
    }

    useEffect(() => {
        let isSubscribing = true
        doesImageExist(
            user?.img,
            () => {
                if (isSubscribing) {
                    setImgLoading(false)
                    setShowInitials(false)
                }
            },
            () => isSubscribing && initInitialAvatar()
        )

        return () => {
            isSubscribing = false
        }
    }, [user?.img])

    const getNameInitials = () => {
        let fullName = ""

        try {
            return user.getInitials()
        } catch (error) {
            return fullName
        }
    }

    const minWidth = size === "large" ? 38 : size === "small" ? 24 : size
    const minHeight = size === "large" ? 38 : size === "small" ? 24 : size

    const onError = () => {
        initInitialAvatar()
        return false
    }

    return (
        <div style={{ height: minHeight + 8, width: minWidth + 14 }} className="flex flex-shrink-0 justify-center items-center">
            {imgLoading ? (
                <Skeleton.Avatar key={user?.id} className={`min-w-${minWidth} min-h-${minHeight}`} active={true} size={size} />
            ) : showInitials ? (
                <Avatar key={user?.id} size={size} className={`animation-appear min-w-${minWidth} min-h-${minHeight}`} style={{ color: GREEN, backgroundColor: "#ffffff" }}>
                    <span className="items-center self-center">{getNameInitials().trim()}</span>
                </Avatar>
            ) : (
                <Avatar key={user?.id} className={`min-w-${minWidth} min-h-${minHeight} bg-white`} size={size} src={user?.img} alt="User image" onError={onError} />
            )}
        </div>
    )
}

export default UserImage
